import { factMarkerStyle } from "helpers/map";
import React from "react";
import { CircleMarker, Polyline } from "react-leaflet";

const SupportPoints = React.memo((props) => {
    const { supportPoints, supportRoute } = props;
    return (
        <>
            <Polyline positions={supportRoute} />
            {supportPoints.map((point, index) => (
                <CircleMarker key={index} center={[point[1], point[0]]} {...factMarkerStyle} radius={5} />
            ))}
        </>
    );
});

export default SupportPoints;
